var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.75 6A2.25 2.25 0 0 0 42 3.75v-1.5A2.25 2.25 0 0 0 39.75 0H8.25A2.25 2.25 0 0 0 6 2.25v1.5A2.25 2.25 0 0 0 8.25 6c0 8.528 4.783 15.725 11.329 18C13.033 26.275 8.25 33.472 8.25 42A2.25 2.25 0 0 0 6 44.25v1.5A2.25 2.25 0 0 0 8.25 48h31.5A2.25 2.25 0 0 0 42 45.75v-1.5A2.25 2.25 0 0 0 39.75 42c0-8.528-4.783-15.725-11.329-18 6.546-2.275 11.329-9.472 11.329-18z",
    id: "ybuwwnsdja"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jwy7soqbxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ybuwwnsdja"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#ybuwwnsdja"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#jwy7soqbxb)",
    fill: "#1890FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassFull);
export default __webpack_public_path__ + "static/media/hourglass-full.f7817f985e75947abc52d05e1c718e7a.svg";
export { ForwardRef as ReactComponent };